//Menu Actions
export const FETCH_MENU_ITEMS = 'FETCH_MENU_ITEMS';
export const REFRESH_MENU = 'REFRESH_MENU';

//Alert Actions
export const POP_ALERT = 'POP_ALERT';
export const DESTROY_ALERT = 'DESTROY_ALERT';

//Help Actions
export const OPEN_HELP = 'OPEN_HELP';
export const CLOSE_HELP = 'CLOSE_HELP';




